"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _ProductPositionDetailsComponent = _interopRequireDefault(require("./ProductPositionDetailsComponent"));
var _FiatDeposit = require("../Retail/RetailSidePanes/FiatDeposit");
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var position = state.apexCore.position,
    translations = state.i18nState.translations;
  var fetching = (0, _productPositionSelectors.fetchingSelector)(state);
  var positionDetails = (0, _productPositionSelectors.productPositionAssetsSelector)(state).find(function (i) {
    return i.ProductId === position.selectedProductId;
  });
  var userInfo = state.user.userInfo;
  return {
    user: userInfo,
    positionDetails: positionDetails,
    translations: translations,
    fetching: fetching,
    DepositReferenceIdModalComponent: /*#__PURE__*/_react["default"].createElement(_FiatDeposit.DepositReferenceIdModalContainer, null)
  };
};
var mapDispatchToProps = {
  openDepositSidePane: _sidePaneActions.openDepositSidePane,
  openWithdrawSidePane: _sidePaneActions.openWithdrawSidePane
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ProductPositionDetailsComponent["default"]);